module.exports = __webpack_public_path__ + "pc-download-logo-11b8176d.png";